module.exports = __webpack_public_path__ + "img/Rectangle.8fb0b94a.png";